module.exports = __webpack_public_path__ + "static/FlutterQRReader2-c9f076169729c1eabdbc6f70991aa79f.jpg";